import React from 'react';
import {format} from "date-fns";
import Logo from "../components/Icons/Logo";
import Icon from "../components/Icons/Icon";
import {scrollToElement} from "../helpers/Animation";

const FooterSection = (props) => {
    
    const logoOnClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        
        scrollToElement('.nav-container', () => console.log('FINISH SCROLL'));
    }
    
    const renderExternalLink = (url, icon, label) => {
        return (
            <a key={'nav-'+url+label}
               href={url}
               className={"icon ms-md-4 mx-2"}
               target={"_blank"}
            >
                <Icon
                    className={icon}
                    title={label}
                />
            </a>
        );
    }
    
    return (
        <footer id="footer-section">
            <div className="section-guttering-container">
                <div className="section-guttering-inner">
                    <div className="footer-upper row m-0 p-0 py-5 border-bottom border-theme-white">
                        <div className="col-12 col-md-6 m-0 mb-2 mb-md-0 p-0 pe-md-4 d-flex justify-content-center justify-content-md-start align-items-center">
                            <Logo
                                type="light"
                                onClick={(event) => logoOnClick(event)}
                            />
                        </div>
                        <div className="col-12 col-md-6 m-0 p-0 ps-md-4 d-flex justify-content-center justify-content-md-end align-items-center">
                            <div className="icon-container">
                                {renderExternalLink('https://www.instagram.com/conahtucker?igsh=MXgzZ20ya3FzODhheQ==', 'text-theme-white fab fa-instagram', 'Instagram')}
                            </div>
                        </div>
                    </div>
                    <div className="footer-lower py-5 d-flex justify-content-center align-items-center">
                        <div className="date m-0 p-0 h5 text-theme-white small">
                            &copy; {format(new Date(), 'yyyy')}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default FooterSection;